interface Favorites {
  jobId: string;
  occupationId: string;
  date: string;
  value: number;
};

const favorites: Array<Favorites> = [
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-01',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-02',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-03',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-04',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-05',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-06',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-07',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-08',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-09',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-10',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-11',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-12',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-13',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-14',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-15',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-16',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-17',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-18',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-19',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-20',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-21',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-22',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-23',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-24',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-25',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-26',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-27',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-28',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-29',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-30',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-01',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-02',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-03',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-04',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-05',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-06',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-07',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-08',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-09',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-10',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-11',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-12',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-13',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-14',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-15',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-16',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-17',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-18',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-19',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-20',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-21',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-22',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-23',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-24',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-25',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-26',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-27',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-28',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-29',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-30',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-31',
    value: 5
  },
  {
    jobId: '2',
    occupationId: '1',
    date: '2021-04-01',
    value: 1
  },
  {
    jobId: '3',
    occupationId: '1',
    date: '2021-04-02',
    value: 2
  },
  {
    jobId: '4',
    occupationId: '1',
    date: '2021-04-03',
    value: 3
  },
  {
    jobId: '5',
    occupationId: '1',
    date: '2021-04-04',
    value: 4
  },
  {
    jobId: '6',
    occupationId: '1',
    date: '2021-04-05',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '2',
    date: '2021-04-06',
    value: 1
  },
  {
    jobId: '2',
    occupationId: '2',
    date: '2021-04-07',
    value: 2
  },
  {
    jobId: '3',
    occupationId: '2',
    date: '2021-04-08',
    value: 3
  },
  {
    jobId: '4',
    occupationId: '2',
    date: '2021-04-09',
    value: 4
  },
  {
    jobId: '5',
    occupationId: '2',
    date: '2021-04-10',
    value: 5
  },
  {
    jobId: '6',
    occupationId: '2',
    date: '2021-04-11',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '3',
    date: '2021-04-12',
    value: 2
  },
  {
    jobId: '2',
    occupationId: '3',
    date: '2021-04-13',
    value: 3
  },
  {
    jobId: '3',
    occupationId: '3',
    date: '2021-04-14',
    value: 4
  },
  {
    jobId: '4',
    occupationId: '3',
    date: '2021-04-15',
    value: 5
  },
  {
    jobId: '5',
    occupationId: '3',
    date: '2021-04-16',
    value: 1
  },
  {
    jobId: '6',
    occupationId: '3',
    date: '2021-04-17',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '4',
    date: '2021-04-18',
    value: 3
  },
  {
    jobId: '2',
    occupationId: '4',
    date: '2021-04-19',
    value: 4
  },
  {
    jobId: '3',
    occupationId: '4',
    date: '2021-04-20',
    value: 5
  },
  {
    jobId: '4',
    occupationId: '4',
    date: '2021-04-21',
    value: 1
  },
  {
    jobId: '5',
    occupationId: '4',
    date: '2021-04-22',
    value: 2
  },
  {
    jobId: '6',
    occupationId: '4',
    date: '2021-04-23',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-04-24',
    value: 4
  },
  {
    jobId: '2',
    occupationId: '1',
    date: '2021-04-25',
    value: 5
  },
  {
    jobId: '3',
    occupationId: '1',
    date: '2021-04-26',
    value: 1
  },
  {
    jobId: '4',
    occupationId: '1',
    date: '2021-04-27',
    value: 2
  },
  {
    jobId: '5',
    occupationId: '1',
    date: '2021-04-28',
    value: 3
  },
  {
    jobId: '6',
    occupationId: '1',
    date: '2021-04-29',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '2',
    date: '2021-04-30',
    value: 5
  },
  {
    jobId: '2',
    occupationId: '2',
    date: '2021-05-01',
    value: 5
  },
  {
    jobId: '3',
    occupationId: '2',
    date: '2021-05-02',
    value: 4
  },
  {
    jobId: '4',
    occupationId: '2',
    date: '2021-05-03',
    value: 3
  },
  {
    jobId: '5',
    occupationId: '2',
    date: '2021-05-04',
    value: 2
  },
  {
    jobId: '6',
    occupationId: '2',
    date: '2021-05-05',
    value: 1
  },
  {
    jobId: '1',
    occupationId: '3',
    date: '2021-05-06',
    value: 5
  },
  {
    jobId: '2',
    occupationId: '3',
    date: '2021-05-07',
    value: 4
  },
  {
    jobId: '3',
    occupationId: '3',
    date: '2021-05-08',
    value: 3
  },
  {
    jobId: '4',
    occupationId: '3',
    date: '2021-05-09',
    value: 2
  },
  {
    jobId: '5',
    occupationId: '3',
    date: '2021-05-10',
    value: 1
  },
  {
    jobId: '6',
    occupationId: '3',
    date: '2021-05-11',
    value: 5
  },
  {
    jobId: '1',
    occupationId: '4',
    date: '2021-05-12',
    value: 4
  },
  {
    jobId: '2',
    occupationId: '4',
    date: '2021-05-13',
    value: 3
  },
  {
    jobId: '3',
    occupationId: '4',
    date: '2021-05-14',
    value: 2
  },
  {
    jobId: '4',
    occupationId: '4',
    date: '2021-05-15',
    value: 1
  },
  {
    jobId: '5',
    occupationId: '4',
    date: '2021-05-16',
    value: 5
  },
  {
    jobId: '6',
    occupationId: '4',
    date: '2021-05-17',
    value: 4
  },
  {
    jobId: '1',
    occupationId: '1',
    date: '2021-05-18',
    value: 3
  },
  {
    jobId: '2',
    occupationId: '1',
    date: '2021-05-19',
    value: 2
  },
  {
    jobId: '3',
    occupationId: '1',
    date: '2021-05-20',
    value: 1
  },
  {
    jobId: '4',
    occupationId: '1',
    date: '2021-05-21',
    value: 5
  },
  {
    jobId: '5',
    occupationId: '1',
    date: '2021-05-22',
    value: 4
  },
  {
    jobId: '6',
    occupationId: '1',
    date: '2021-05-23',
    value: 3
  },
  {
    jobId: '1',
    occupationId: '2',
    date: '2021-05-24',
    value: 2
  },
  {
    jobId: '2',
    occupationId: '2',
    date: '2021-05-25',
    value: 1
  },
  {
    jobId: '3',
    occupationId: '2',
    date: '2021-05-26',
    value: 5
  },
  {
    jobId: '4',
    occupationId: '2',
    date: '2021-05-27',
    value: 4
  },
  {
    jobId: '5',
    occupationId: '2',
    date: '2021-05-28',
    value: 3
  },
  {
    jobId: '6',
    occupationId: '2',
    date: '2021-05-29',
    value: 2
  },
  {
    jobId: '1',
    occupationId: '3',
    date: '2021-05-30',
    value: 1
  },
  {
    jobId: '2',
    occupationId: '3',
    date: '2021-05-31',
    value: 5
  }
];

export default favorites;
